// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3phXo","header":"PatientBlock_header__3MkSa","label":"PatientBlock_label__2rPqo","option":"PatientBlock_option__1qe0j"};